const showYear = (self) => {
  const years = self.HTMLElement.querySelectorAll("[data-calendar-selected-year]");
  if (!years || self.selectedMonth === void 0)
    return;
  const initDate = new Date(self.selectedYear, self.selectedMonth, 1);
  years.forEach((_, index) => {
    const selectedYear = new Date(initDate.setFullYear(self.selectedYear, self.selectedMonth + index)).getFullYear();
    years[index].dataset.calendarSelectedYear = String(selectedYear);
    years[index].innerText = String(selectedYear);
    if (!self.settings.selection.year || self.currentType === "multiple") {
      years[index].tabIndex = -1;
      years[index].classList.add(self.CSSClasses.yearDisabled);
    } else {
      years[index].tabIndex = 0;
      years[index].classList.remove(self.CSSClasses.yearDisabled);
    }
  });
};
export {
  showYear as default
};
